/* __next_internal_client_entry_do_not_use__ FakeAnchor auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import React from "react";
import styled from "styled-components";
export var FakeAnchor = function(param) {
    var id = param.id;
    useTraceComponentRender("FakeAnchor");
    var _useTopOfPageContent = useTopOfPageContent(), actualHeight = _useTopOfPageContent.headerPlusPromoBannerHeight;
    var isSSR = useIsSSR();
    var height = isSSR ? 0 : actualHeight;
    var _React_useState = _sliced_to_array(React.useState("-".concat(height, "px")), 2), top = _React_useState[0], setTop = _React_useState[1];
    // using a state instead the observable value because the latter is updated
    // at a rendering time which is causing some warnings
    React.useEffect(function() {
        setTop("-".concat(height, "px"));
    }, [
        height
    ]);
    return /*#__PURE__*/ _jsx(StyledDiv, {
        id: id,
        $top: top
    });
};
var StyledDiv = styled.div.withConfig({
    componentId: "sc-718448b-0"
})([
    "visibility:hidden;position:relative;top:",
    ";"
], function(props) {
    return props.$top;
});
